import { Fragment } from 'react';
import { CSSTransition } from 'react-transition-group';
import { ExchangeState, rage, useObservable } from '~/rage';
import { PropertyList } from '../PropertyList';
import { Offer } from '../Offer';
import { Confirmation } from '../Confirmation';
import { StyledContainer, StyledDivider } from './Exchange.styled';

const Exchange: React.FC = () => {
	const exchangeState = useObservable(rage.exchange.getExchangeState());

	return (
		<Fragment>
			<StyledContainer
				style={{
					opacity: exchangeState === ExchangeState.ConfirmingExchange ? 0.1 : 1,
				}}
			>
				<PropertyList />
				<StyledDivider />
				<Offer />
			</StyledContainer>
			<CSSTransition
				in={exchangeState === ExchangeState.ConfirmingExchange}
				timeout={300}
				classNames={'confirm'}
				unmountOnExit
			>
				<Confirmation />
			</CSSTransition>
		</Fragment>
	);
};

export { Exchange };
